import React, { useRef, useState } from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import { Grid } from "@mui/material";
import IntervalDropdown from "../../../../components/IntervalDropdown";
import MultiDropdownApi from "../../../../components/MultiDropdownApi";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Dropdown } from "primereact/dropdown";
import { FREQUENCIES } from "../../../forms-allocation/constants";
import { PTOAdd, PTOUpdate } from "../../../../service/ptoService";
import { QuillEditor } from "../../../../components/QuillEditor";
import { InputTextarea } from "primereact/inputtextarea";
import DropdownApi from "../../../../components/DropdownApi";
export default function PtoTopicsAdd(modalProps: any) {
  const details = modalProps?.details;

  const [name, setName] = useState(details?.name || "");
  const [nameError, setNameError] = useState(false);

  const [description, setDescription] = useState(details?.description || "");
  const [body, setBody] = useState(details?.body || "");
  const [industry, setIndustry] = useState(details?.industry || []);
  const [jobTask, setJobTask] = useState(details?.job_task?.[0] || "");
  const [question, setQuestion] = useState(details?.question || []);

  async function addIndustry() {
    setNameError(!name || name === "");
    if (!name || name === "") {
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Please enter all required fields",
        life: 3000,
      });
      return;
    }
    const updateDetails = {
      name,
      description,
      body,
      industry,
      job_task: [jobTask],
      question,
    };
    if (modalProps.id) {
      PTOUpdate(modalProps.id, updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "PTO Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    } else {
      PTOAdd(updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "PTO Created Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    }
  }

  return (
    <React.Fragment>
      <TabView>
        <TabPanel header="Details">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>
                  Name<div style={{ color: "red" }}>*</div>
                </FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <InputText
                    value={name}
                    onChange={e => setName(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                  />
                </FormControl>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <MultiDropdownApi
                showAll={true}
                apiPath="industry"
                optionLabel="name"
                optionValue="id"
                label="Industry"
                selectedData={industry}
                setSelectedData={setIndustry}
              />
            </Grid>
            <Grid item xs={6}>
              <DropdownApi
                apiPath="risk-job-task"
                optionLabel="name"
                optionValue="id"
                label="Job Task"
                allowAll={true}
                selectedData={jobTask}
                setSelectedData={setJobTask}
              />
            </Grid>
            <Grid item xs={12}>
              <QuillEditor
                label="Description"
                hidePlaceholder={true}
                content={body}
                setContent={setBody}
                toast={modalProps.toast}
              />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel header="Questions">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                <FormLabel>Questions</FormLabel>
                <Button
                  type="button"
                  icon="pi pi-plus"
                  label="Add"
                  className="p-button-outlined"
                  size="small"
                  style={{
                    position: "absolute",
                    right: 0,
                    padding: 10,
                    marginTop: -15,
                  }}
                  onClick={() => {
                    const updatedChecklist = [...question];
                    updatedChecklist.push("");
                    setQuestion(updatedChecklist);
                  }}
                />
              </FormControl>
            </Grid>
            {question.map((checklist: any, index: number) => {
              return (
                <Grid item xs={12} key={index}>
                  <IconField>
                    <InputIcon
                      className="pi pi-trash"
                      style={{ color: "#eb445a" }}
                      onClick={() => {
                        const updatedChecklist = [...question];
                        updatedChecklist.splice(index, 1);
                        setQuestion(updatedChecklist);
                      }}
                    >
                      {" "}
                    </InputIcon>
                    <InputText
                      value={checklist}
                      onChange={e => {
                        const updatedChecklist = [...question];
                        updatedChecklist[index] = e.target.value;
                        setQuestion(updatedChecklist);
                      }}
                      style={{ width: "100%" }}
                      type="text"
                      className="p-inputtext-sm PrimeSmallInput"
                      placeholder={`Please enter question ${index + 1}`}
                    />
                  </IconField>
                </Grid>
              );
            })}
          </Grid>
        </TabPanel>
      </TabView>
      <br />
      <br />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          <Button
            name="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => addIndustry()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
